import getServerErrorMessage from 'app/utilities/getServerErrorMessage';
import { toast } from 'react-toastify';
import { SagaIterator } from 'redux-saga';
import { call, cancelled, put } from 'redux-saga/effects';

import {
  resendPasswordResetEmailAPIRequest,
  resendVerifyEmailAPIRequest,
} from '../api';
import {
  TResendAccountVerificationResponse,
  TResetPasswordServerResponse,
} from '../types';
import {
  clearError,
  endAuthTask,
  resendPasswordResetEmailRequest,
  resendVerifyAccountEmailRequest,
  startAuthTask,
} from './auth-slice';

type TAction = {
  type: string;
  payload: string;
};

export function* resendVerificationEmailSaga({
  payload,
  type,
}: TAction): SagaIterator {
  try {
    yield put(startAuthTask());
    let email = '';
    if (type === resendPasswordResetEmailRequest.type) {
      const { data }: TResetPasswordServerResponse = yield call(
        resendPasswordResetEmailAPIRequest,
        payload
      );
      email = data.user;
    } else if (type === resendVerifyAccountEmailRequest.type) {
      const { data }: TResendAccountVerificationResponse = yield call(
        resendVerifyEmailAPIRequest,
        payload
      );
      email = data.email;
    }

    yield call(toast, `Verification link resent to ${email}`, {
      type: 'success',
    });
  } catch (error) {
    const errorMsg = getServerErrorMessage(error);
    yield call(toast, errorMsg, {
      type: 'error',
    });
  } finally {
    yield put(endAuthTask());
  }
}
